import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class GeneralAnalysisProxy extends ProxyBase {
  getGenericRatioHighlight(params) {
    return this.get('GetGenericRatioHighlight', params)
  }

  getIndustryRatioDetail(params) {
    return this.get('GetIndustryRatioDetail', params)
  }

  getActivitiesRatioAndRisk(params) {
    return this.get('GetActivitiesRatioAndRisk', params, undefined, true)
  }

  getActivitiesRatioAndRiskCompare(params) {
    return this.get('GetActivitiesRatioAndRisk', params, undefined, true)
  }

  getDistributeScoreChart(params) {
    return this.get('GetDistributeScoreChart', params, undefined, true)
  }

  getDistributeScoreCompareChart(params) {
    return this.get('GetDistributeScoreChart', params, undefined, true)
  }

  getIndustryNews(params) {
    return this.get('GetIndustryNews', params)
  }

  exportGeneralAnalysis(params) {
    return this.get('Export', params, 'download')
  }

  getPerformanMatrixChartData(params) {
    return this.get('GetPerformanMatrixChartData', params)
  }

  getPerformanMatrixDisplayData(params) {
    return this.get('GetPerformanMatrixDisplayData', params)
  }
}

export default new GeneralAnalysisProxy('IndustryAnalysis/GeneralAnalysis/')
